// ВАЖНО: React должен быть импортирован первым
import React from 'react';
import ReactDOM from 'react-dom/client';

// Затем React Router
import { BrowserRouter } from 'react-router-dom';

// Затем MUI (после React)
import StyledEngineProvider from '@mui/material/StyledEngineProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

// Затем остальные импорты
import './polyfills';
import './i18'; // <-- Подключение i18n здесь (после React)

// Критический CSS инлайнится в index.html через плагин criticalCSS
// Некритический CSS (index.css) загружается асинхронно
import './index.css';

import { App } from './App';
import { initConfig } from './config';
import axios from 'axios';
import { getBaseUrl } from './services/api';

// Загружаем config с server перед render
// Это позволяет использовать runtime env vars без rebuild
window.dispatchEvent(new CustomEvent('butterfly-startup-stage', { detail: 'Код приложения загружен; получаем настройки сервера' }));
initConfig().then(() => {
  window.dispatchEvent(new CustomEvent('butterfly-startup-stage', { detail: 'Приложение запускается; загружаем экран и данные луга' }));
  axios.defaults.baseURL = getBaseUrl();
  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <StyledEngineProvider injectFirst>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <App />
        </LocalizationProvider>
      </StyledEngineProvider>
    </BrowserRouter>
  );
});
